import axios from 'axios';
import { getCreatorOnboardingToken } from './sessionStorage';

const API_URL = process.env.REACT_APP_API_URL || '';

const onboardingClient = axios.create({
  baseURL: `${API_URL}/creator-portal`,
  withCredentials: true,
});

onboardingClient.interceptors.request.use((config) => {
  const token = getCreatorOnboardingToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getOnboardingContent = () => onboardingClient.get('/onboarding/content');

export const completeOnboarding = (walletAddress, creatorType = 'web3') => onboardingClient.post('/onboarding/complete', {
  walletAddress,
  creatorType
});

export const getOnboardingVideoBlob = async (videoUrl) => {
  const response = await onboardingClient.get(videoUrl.replace('/creator-portal', ''), {
    responseType: 'blob'
  });
  return URL.createObjectURL(response.data);
};
